// PieChart.tsx
import React from "react";
import ApexCharts from "react-apexcharts";
import { ApexOptions } from "apexcharts";
import { useTheme } from "@mui/material/styles";


interface PieOptionProps {
    name: string;
    data: number[];
    labels: string[];
}
const FacilityPieChart: React.FC<PieOptionProps> = ({name, data, labels}) => {
  const series = data; // Your 4 values here

  const options: ApexOptions = {
    chart: {
      type: "pie",
      toolbar: {
        show: false, // Disable the toolbar (menu)
      },
    },
    labels: labels, // Labels for each segment
    title: {
      text: name,
      align: "center",
    },
    colors: ["#6881C8", "#93A5D8", "#D4DBEF", "#284CB1"], // Optional: Custom colors
    dataLabels: {
      enabled: true, // Display data labels
    },
    legend: {
      position: "bottom", // Position of the legend
      markers: {
        shape: "square",
      },
    },
  };

  return (
    <ApexCharts options={options} series={series} type="pie" height={250} />
  );
};

export default FacilityPieChart;
